/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Jobs_Bell_LabelInputs */

const cs_jobs_bell_label = /** @type {(inputs: Jobs_Bell_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Oznámení a úlohy (${i?.count})`)
};

const en_jobs_bell_label = /** @type {(inputs: Jobs_Bell_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Notifications and jobs (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Notifications and jobs ({count})" |
*
* @param {Jobs_Bell_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const jobs_bell_label = /** @type {((inputs: Jobs_Bell_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Bell_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jobs_bell_label(inputs)
	return cs_jobs_bell_label(inputs)
});